export default "__VITE_ASSET__DYCWqZOb__"